const handleProductQuick = (product) => {
  const productId = product.getAttribute("data-product-id");
  const btnSubmit = product.querySelector(".add-to-cart");
  let fakeBtnSubmit = product.querySelector(".fake__btn");
  const backorder = product.querySelector(".backorder");

  product.querySelectorAll("fieldset").forEach((fieldset) => {
    const optionName = fieldset.querySelector("legend").id.split("--")[1];
    const position = fieldset.getAttribute("data-position");
    const labels = fieldset.querySelectorAll("label");
    const productJson = product.querySelector("[data-product-json]");
    const stringify = JSON.stringify(productJson.innerHTML);

    const productJsonData = JSON.parse(stringify);

    labels.forEach((label) => {
      label.addEventListener("click", () => {
        labels.forEach((element) =>
          element.classList.remove("variant_selected")
        );
        const value = label.getAttribute("aria-label");
        const variant = findVariants(
          value,
          position,
          productId,
          product,
          productJsonData
        );

        const textContainer = fieldset.querySelector(
          `#legend--${optionName} .option__value`
        );

        fieldset.querySelector(
          `#legend--${optionName} .option__value`
        ).innerHTML = `${value}`;

        label.classList.add("variant_selected");

        const unavailableStr = variant ? "Notify me" : theme.strings.noVariant;

        if (!variant) {
          fakeBtnSubmit.style.display = "block";
          btnSubmit.style.display = "none";
          fakeBtnSubmit.innerHTML = unavailableStr;
          fakeBtnSubmit.disabled = true;
          return;
        }
        fakeBtnSubmit.disabled = false;
        fakeBtnSubmit.innerHTML = unavailableStr;

        const variantId = variant?.id || 0;
        const productData = {
          id: productJsonData.id,
          variants: [{ id: variantId, available: false }],
        };

        const onOpenModal = (event) => {
          event.preventDefault();
          event.stopPropagation();
          window._RestockRocket &&
            window._RestockRocket.openModal(productData, variantId);
        };

        const clearEventListeners = (element) => {
          const newElement = element.cloneNode(true);
          element.replaceWith(newElement);
          return newElement;
        };

        const input = product.querySelector("input[name='id']");
        input.value = variantId;

        const image = product.querySelector(".quick-add-product-img");
        if (image) {
          image.src = variant.featured_image.src;
          image.srcset = variant.featured_image.src;
        }

        if (variant.available) {
          fakeBtnSubmit.style.display = "none";
          btnSubmit.style.display = "block";
          if (
            variant.inventory_management == "shopify" &&
            variant.inventory_quantity < 1
          ) {
            if (isProductBlock) {
              btnSubmit.innerHTML = "Pre-order";
              return;
            }
            backorder?.removeAttribute("hidden");
            return;
          }
          backorder?.setAttribute("hidden", true);
          if (isProductBlock) {
            btnSubmit.innerHTML = "Add to cart";
          }
        } else {
          fakeBtnSubmit.style.display = "block";
          btnSubmit.style.display = "none";
          fakeBtnSubmit = clearEventListeners(fakeBtnSubmit);
          fakeBtnSubmit.addEventListener("click", onOpenModal);
        }
      });
    });
  });
};

const findVariants = (option, position, productId, productEle, data) => {
  const product = JSON.parse(data);
  if (!product) return;
  const positionOption2 = position - 1 === 0 ? 1 : 0;

  product.variants.forEach((variant) => {
    if (variant.options.length <= 1) return;
    if (variant.options[position - 1] === option) {
      const option2 = variant.options[positionOption2];
      const element2 = productEle.querySelector(
        `label[aria-label="${option2}"]`
      );

      // if (variant.inventory_quantity === 0) {
      //   element2.classList.add("sold-out");
      // } else element2.classList.remove("sold-out");
    }
  });

  const selectedOptionVariant2 = productEle.querySelector(
    `fieldset[data-position="${positionOption2 + 1}"] .option__value`
  );

  const newOptions = [selectedOptionVariant2?.innerHTML, option].filter(
    Boolean
  );

  return product.variants.find(
    (item) =>
      item.options.length === newOptions.length &&
      item.options.every((value) => newOptions.includes(value))
  );
};

const wrap = (toWrap, wrapperClass = "", wrapperOption) => {
  const wrapper = wrapperOption || document.createElement("div");
  wrapper.classList.add(wrapperClass);
  toWrap.parentNode.insertBefore(wrapper, toWrap);
  return wrapper.appendChild(toWrap);
};

function wrapElements(container) {
  // Target tables to make them scrollable
  const tableSelectors = ".rte table";
  const tables = container.querySelectorAll(tableSelectors);
  tables.forEach((table) => {
    wrap(table, "rte__table-wrapper");
    table.setAttribute("data-scroll-lock-scrollable", "");
  });

  // Target iframes to make them responsive
  const iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe';
  const frames = container.querySelectorAll(iframeSelectors);
  frames.forEach((frame) => {
    wrap(frame, "rte__video-wrapper");
  });
}

function isTouchDevice() {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}

function isTouch() {
  if (isTouchDevice()) {
    document.documentElement.className =
      document.documentElement.className.replace("no-touch", "supports-touch");
    window.theme.touch = true;
  } else {
    window.theme.touch = false;
  }
}

function ariaToggle(container) {
  const toggleButtons = container.querySelectorAll("[data-aria-toggle]");
  if (toggleButtons.length) {
    toggleButtons.forEach((element) => {
      element.addEventListener("click", function (event) {
        event.preventDefault();
        const currentTarget = event.currentTarget;
        currentTarget.setAttribute(
          "aria-expanded",
          currentTarget.getAttribute("aria-expanded") == "false"
            ? "true"
            : "false"
        );
        const toggleID = currentTarget.getAttribute("aria-controls");
        const toggleElement = document.querySelector(`#${toggleID}`);
        const removeExpandingClass = () => {
          toggleElement.classList.remove("expanding");
          toggleElement.removeEventListener(
            "transitionend",
            removeExpandingClass
          );
        };
        const addExpandingClass = () => {
          toggleElement.classList.add("expanding");
          toggleElement.removeEventListener(
            "transitionstart",
            addExpandingClass
          );
        };

        toggleElement.addEventListener("transitionstart", addExpandingClass);
        toggleElement.addEventListener("transitionend", removeExpandingClass);

        toggleElement.classList.toggle("expanded");
      });
    });
  }
}

function isVisible(el) {
  var style = window.getComputedStyle(el);
  return style.display !== "none" && style.visibility !== "hidden";
}

/**
 * Moves focus to an HTML element
 * eg for In-page links, after scroll, focus shifts to content area so that
 * next `tab` is where user expects. Used in bindInPageLinks()
 * eg move focus to a modal that is opened. Used in trapFocus()
 *
 * @param {Element} container - Container DOM element to trap focus inside of
 * @param {Object} options - Settings unique to your theme
 * @param {string} options.className - Class name to apply to element on focus.
 */
function forceFocus(element, options) {
  options = options || {};

  var savedTabIndex = element.tabIndex;

  element.tabIndex = -1;
  element.dataset.tabIndex = savedTabIndex;
  element.focus();
  if (typeof options.className !== "undefined") {
    element.classList.add(options.className);
  }
  element.addEventListener("blur", callback);

  function callback(event) {
    event.target.removeEventListener(event.type, callback);

    element.tabIndex = savedTabIndex;
    delete element.dataset.tabIndex;
    if (typeof options.className !== "undefined") {
      element.classList.remove(options.className);
    }
  }
}

/**
 * If there's a hash in the url, focus the appropriate element
 * This compensates for older browsers that do not move keyboard focus to anchor links.
 * Recommendation: To be called once the page in loaded.
 *
 * @param {Object} options - Settings unique to your theme
 * @param {string} options.className - Class name to apply to element on focus.
 * @param {string} options.ignore - Selector for elements to not include.
 */

function focusHash(options) {
  options = options || {};
  var hash = window.location.hash;
  var element = document.getElementById(hash.slice(1));

  // if we are to ignore this element, early return
  if (element && options.ignore && element.matches(options.ignore)) {
    return false;
  }

  if (hash && element) {
    forceFocus(element, options);
  }
}

/**
 * When an in-page (url w/hash) link is clicked, focus the appropriate element
 * This compensates for older browsers that do not move keyboard focus to anchor links.
 * Recommendation: To be called once the page in loaded.
 *
 * @param {Object} options - Settings unique to your theme
 * @param {string} options.className - Class name to apply to element on focus.
 * @param {string} options.ignore - CSS selector for elements to not include.
 */

function bindInPageLinks(options) {
  options = options || {};
  var links = Array.prototype.slice.call(
    document.querySelectorAll('a[href^="#"]')
  );

  function queryCheck(selector) {
    return document.getElementById(selector) !== null;
  }

  return links.filter(function (link) {
    if (link.hash === "#" || link.hash === "") {
      return false;
    }

    if (options.ignore && link.matches(options.ignore)) {
      return false;
    }

    if (!queryCheck(link.hash.substr(1))) {
      return false;
    }

    var element = document.querySelector(link.hash);

    if (!element) {
      return false;
    }

    link.addEventListener("click", function () {
      forceFocus(element, options);
    });

    return true;
  });
}

function focusable(container) {
  var elements = Array.prototype.slice.call(
    container.querySelectorAll(
      "[tabindex]," +
        "[draggable]," +
        "a[href]," +
        "area," +
        "button:enabled," +
        "input:not([type=hidden]):enabled," +
        "object," +
        "select:enabled," +
        "textarea:enabled"
    )
  );

  // Filter out elements that are not visible.
  // Copied from jQuery https://github.com/jquery/jquery/blob/2d4f53416e5f74fa98e0c1d66b6f3c285a12f0ce/src/css/hiddenVisibleSelectors.js
  return elements.filter(function (element) {
    return !!(
      (element.offsetWidth ||
        element.offsetHeight ||
        element.getClientRects().length) &&
      isVisible(element)
    );
  });
}

/**
 * Traps the focus in a particular container
 *
 * @param {Element} container - Container DOM element to trap focus inside of
 * @param {Element} elementToFocus - Element to be focused on first
 * @param {Object} options - Settings unique to your theme
 * @param {string} options.className - Class name to apply to element on focus.
 */

function trapFocus(container, options) {
  options = options || {};
  var elements = focusable(container);
  var elementToFocus = options.elementToFocus || container;
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = function (event) {
    if (
      container !== event.target &&
      !container.contains(event.target) &&
      first &&
      first === event.target
    ) {
      first.focus();
    }

    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;
    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code !== "Tab") return; // If not TAB key

    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  forceFocus(elementToFocus, options);
}

/**
 * Removes the trap of focus from the page
 */
function removeTrapFocus() {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
}

/**
 * Auto focus the last element
 */
function autoFocusLastElement() {}

/**
 * Add a preventive message to external links and links that open to a new window.
 * @param {string} elements - Specific elements to be targeted
 * @param {object} options.messages - Custom messages to overwrite with keys: newWindow, external, newWindowExternal
 * @param {string} options.messages.newWindow - When the link opens in a new window (e.g. target="_blank")
 * @param {string} options.messages.external - When the link is to a different host domain.
 * @param {string} options.messages.newWindowExternal - When the link is to a different host domain and opens in a new window.
 * @param {object} options.prefix - Prefix to namespace "id" of the messages
 */
function accessibleLinks(elements, options) {
  if (typeof elements !== "string") {
    throw new TypeError(elements + " is not a String.");
  }

  elements = document.querySelectorAll(elements);

  if (elements.length === 0) {
    return;
  }

  options = options || {};
  options.messages = options.messages || {};

  var messages = {
    newWindow: options.messages.newWindow || "Opens in a new window.",
    external: options.messages.external || "Opens external website.",
    newWindowExternal:
      options.messages.newWindowExternal ||
      "Opens external website in a new window.",
  };

  var prefix = options.prefix || "a11y";

  var messageSelectors = {
    newWindow: prefix + "-new-window-message",
    external: prefix + "-external-message",
    newWindowExternal: prefix + "-new-window-external-message",
  };

  function generateHTML(messages) {
    var container = document.createElement("ul");
    var htmlMessages = Object.keys(messages).reduce(function (html, key) {
      return (html +=
        "<li id=" + messageSelectors[key] + ">" + messages[key] + "</li>");
    }, "");

    container.setAttribute("hidden", true);
    container.innerHTML = htmlMessages;

    document.body.appendChild(container);
  }

  function externalSite(link) {
    return link.hostname !== window.location.hostname;
  }

  elements.forEach(function (link) {
    var target = link.getAttribute("target");
    var rel = link.getAttribute("rel");
    var isExternal = externalSite(link);
    var isTargetBlank = target === "_blank";
    var missingRelNoopener = rel === null || rel.indexOf("noopener") === -1;

    if (isTargetBlank && missingRelNoopener) {
      var relValue = rel === null ? "noopener" : rel + " noopener";
      link.setAttribute("rel", relValue);
    }

    if (isExternal && isTargetBlank) {
      link.setAttribute("aria-describedby", messageSelectors.newWindowExternal);
    } else if (isExternal) {
      link.setAttribute("aria-describedby", messageSelectors.external);
    } else if (isTargetBlank) {
      link.setAttribute("aria-describedby", messageSelectors.newWindow);
    }
  });

  generateHTML(messages);
}

var a11y = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  forceFocus: forceFocus,
  focusHash: focusHash,
  bindInPageLinks: bindInPageLinks,
  focusable: focusable,
  trapFocus: trapFocus,
  removeTrapFocus: removeTrapFocus,
  autoFocusLastElement: autoFocusLastElement,
  accessibleLinks: accessibleLinks,
});

function hasOpenModals() {
  const openModals = Boolean(
    document.querySelectorAll("dialog[open][data-scroll-lock-required]").length
  );
  const openDrawers = Boolean(
    document.querySelectorAll(".drawer.is-open").length
  );

  return openModals || openDrawers;
}

const classes$i = {
  added: "is-added",
  animated: "is-animated",
  disabled: "is-disabled",
  error: "has-error",
  loading: "is-loading",
  open: "is-open",
  overlayText: "product-item--overlay-text",
  visible: "is-visible",
  siblingLinkCurrent: "sibling__link--current",
};
const selectors$p = {
  animation: "[data-animation]",
  apiContent: "[data-api-content]",
  buttonQuickAdd: "[data-quick-add-btn]",
  buttonAddToCart: "[data-add-to-cart]",
  cartDrawer: "cart-drawer",
  cartPage: "[data-cart-page]",
  cartLineItems: "[data-line-items]",
  dialog: "dialog",
  focusable:
    'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
  messageError: "[data-message-error]",
  modalButton: "[data-quick-add-modal-handle]",
  modalContainer: "[data-product-upsell-container]",
  modalContent: "[data-product-upsell-ajax]",
  modalClose: "[data-quick-add-modal-close]",
  productGridItem: "data-grid-item",
  productInformationHolder: "[data-product-information]",
  quickAddHolder: "[data-quick-add-holder]",
  quickAddModal: "[data-quick-add-modal]",
  quickAddModalTemplate: "[data-quick-add-modal-template]",
};

const attributes$i = {
  closing: "closing",
  productId: "data-product-id",
  modalHandle: "data-quick-add-modal-handle",
  siblingSwapper: "data-sibling-swapper",
  quickAddHolder: "data-quick-add-holder",
};

class QuickAddProduct extends HTMLElement {
  constructor() {
    super();
    this.scrollY = 0;
    this.container = this;
    this.cart =
      document.querySelector(selectors$p.cartDrawer) ||
      document.querySelector(selectors$p.cartPage);
    this.quickAddHolder = this.container.querySelector(
      selectors$p.quickAddHolder
    );
    this.isOpenCart = false;

    if (this.quickAddHolder) {
      this.modal = null;
      this.currentModal = null;
      this.productId = this.quickAddHolder.getAttribute(
        attributes$i.quickAddHolder
      );
      this.modalButton = this.quickAddHolder.querySelector(
        selectors$p.modalButton
      );
      this.handle = this.modalButton?.getAttribute(attributes$i.modalHandle);
      this.cartDrawer = document.querySelector(selectors$p.cartDrawer);
      this.buttonQuickAdd = this.quickAddHolder.querySelector(
        selectors$p.buttonQuickAdd
      );

      this.buttonATC = this.quickAddHolder.querySelector(
        selectors$p.buttonAddToCart
      );

      this.button = this.modalButton || this.buttonATC;
      this.modalClose = this.modalClose.bind(this);
      this.modalCloseOnProductAdded = this.modalCloseOnProductAdded.bind(this);
      this.a11y = a11y;
      this.isAnimating = false;

      this.modalButtonClickEvent = this.modalButtonClickEvent.bind(this);
      this.quickAddLoadingToggle = this.quickAddLoadingToggle.bind(this);
    }
  }

  connectedCallback() {
    /**
     * Modal button works for multiple variants products
     */
    if (this.modalButton) {
      this.modalButton.addEventListener("click", this.modalButtonClickEvent);
    }

    /**
     * Quick add button works for single variant products
     */
    if (this.buttonATC && this.cart) {
      this.buttonATC.addEventListener("click", (e) => {
        e.preventDefault();

        window.accessibility.lastElement = this.buttonATC;

        document.dispatchEvent(
          new CustomEvent("theme:cart:add", {
            detail: {
              button: this.buttonATC,
            },
          })
        );
      });
    }

    if (this.quickAddHolder) {
      this.quickAddHolder.addEventListener(
        "animationend",
        this.quickAddLoadingToggle
      );
      this.errorHandler();
    }
  }

  modalButtonClickEvent(e) {
    this.scrollY = window.scrollY;
    e.preventDefault();
    const isSiblingSwapper = this.modalButton.hasAttribute(
      attributes$i.siblingSwapper
    );
    const isSiblingLinkCurrent = this.modalButton.classList.contains(
      classes$i.siblingLinkCurrent
    );

    if (isSiblingLinkCurrent) return;

    this.modalButton.classList.add(classes$i.loading);
    this.modalButton.disabled = true;

    // Siblings product modal swapper
    if (isSiblingSwapper && !isSiblingLinkCurrent) {
      this.currentModal = e.target.closest(selectors$p.quickAddModal);
      this.currentModal.classList.add(classes$i.loading);
    }

    this.renderModal();
  }

  modalCreate(response) {
    const cachedModal = document.querySelector(
      `${selectors$p.quickAddModal}[${attributes$i.productId}="${this.productId}"]`
    );
    if (cachedModal) {
      this.modal = cachedModal;
      this.modalOpen();
    } else {
      const modalTemplate = this.quickAddHolder.querySelector(
        selectors$p.quickAddModalTemplate
      );
      if (!modalTemplate) return;

      const htmlObject = document.createElement("div");
      htmlObject.innerHTML = modalTemplate.innerHTML;

      // Add dialog to the body
      document.body.appendChild(
        htmlObject.querySelector(selectors$p.quickAddModal)
      );
      modalTemplate.remove();

      this.modal = document.querySelector(
        `${selectors$p.quickAddModal}[${attributes$i.productId}="${this.productId}"]`
      );
      this.modal.querySelector(selectors$p.modalContent).innerHTML =
        new DOMParser()
          .parseFromString(response, "text/html")
          .querySelector(selectors$p.apiContent).innerHTML;

      this.modalCreatedCallback();
      handleProductQuick(this.modal);
    }
  }

  modalOpen() {
    if (this.currentModal) {
      this.currentModal.dispatchEvent(
        new CustomEvent("theme:modal:close", { bubbles: false })
      );
    }
    const cart = document.querySelector("cart-drawer");
    if (cart) {
      const isOpenCart = cart.hasAttribute("open");
      if (isOpenCart) {
        this.isOpenCart = true;
        document.dispatchEvent(
          new CustomEvent("dispatch:cart-drawer:close", {
            bubbles: true,
            cancelable: false,
          })
        );
      }
    }

    // Check if browser supports Dialog tags
    if (typeof this.modal.show === "function") {
      this.modal.show();
    }

    this.modal.setAttribute("open", true);
    this.modal.removeAttribute("inert");

    this.quickAddHolder.classList.add(classes$i.disabled);

    if (this.modalButton) {
      this.modalButton.classList.remove(classes$i.loading);
      this.modalButton.disabled = false;
      // window.accessibility.lastElement = this.modalButton;
    }

    // Animate items
    requestAnimationFrame(() => {
      this.modal.querySelectorAll(selectors$p.animation).forEach((item) => {
        item.classList.add(classes$i.animated);
      });
    });

    document.dispatchEvent(
      new CustomEvent("theme:quick-add:open", { bubbles: true })
    );

    document.addEventListener("on:cart:add", this.modalCloseOnProductAdded, {
      once: true,
    });

    document.body.style.overflow = "hidden";
    // document.body.style.top = `-${this.scrollY}px`;
    const productQuickAdd = this.modal.querySelector(
      ".drawer__inner.product-quick-add__content"
    );
    productQuickAdd.scrollTop = productQuickAdd.scrollHeight;
  }

  modalClose() {
    if (this.isAnimating) {
      return;
    }

    if (!this.modal.hasAttribute(attributes$i.closing)) {
      this.modal.setAttribute(attributes$i.closing, "");
      this.isAnimating = true;
      return;
    }

    // Check if browser supports Dialog tags
    if (typeof this.modal.close === "function") {
      this.modal.close();
    } else {
      this.modal.removeAttribute("open");
    }

    this.modal.removeAttribute(attributes$i.closing);
    this.modal.setAttribute("inert", "");
    this.modal.classList.remove(classes$i.loading);

    if (this.modalButton) {
      this.modalButton.disabled = false;
    }

    if (
      this.quickAddHolder &&
      this.quickAddHolder.classList.contains(classes$i.disabled)
    ) {
      this.quickAddHolder.classList.remove(classes$i.disabled);
    }

    this.resetAnimatedItems();

    // Unlock scroll if no other drawers & modals are open
    if (!hasOpenModals()) {
      document.body.style.overflow = "unset";
      // document.body.style.top = "";
      // document.body.classList.remove("fixed");
      // window.scrollTo({
      //   top: `${this.scrollY}`,
      // });
    }

    document.body.style.overflow = "unset";

    document.removeEventListener(
      "theme:product:added",
      this.modalCloseOnProductAdded
    );

    this.a11y.removeTrapFocus();
    this.a11y.autoFocusLastElement();
    if (this.isOpenCart === true) {
      document.dispatchEvent(
        new CustomEvent("dispatch:cart-drawer:open", {
          bubbles: true,
          cancelable: false,
        })
      );
      this.isOpenCart = false;
    }
  }

  modalEvents() {
    // Close button click event
    this.modal
      .querySelector(selectors$p.modalClose)
      ?.addEventListener("click", (e) => {
        e.preventDefault();
        this.modalClose();
      });

    // Close dialog on click outside content
    this.modal.addEventListener("click", (event) => {
      if (event.target.nodeName === "DIALOG" && event.type === "click") {
        this.modalClose();
      }
    });

    // Close dialog on click ESC key pressed
    this.modal.addEventListener("keydown", (event) => {
      if (event.code == "Escape") {
        event.preventDefault();
        this.modalClose();
      }
    });

    this.modal.addEventListener("theme:modal:close", () => {
      this.modalClose();
    });

    // Close dialog after animation completes
    this.modal.addEventListener("animationend", (event) => {
      if (event.target !== this.modal) return;
      this.isAnimating = false;

      if (this.modal.hasAttribute(attributes$i.closing)) {
        this.modalClose();
      } else {
        setTimeout(() => {
          this.a11y.trapFocus(this.modal);
          const focusTarget =
            this.modal.querySelector("[autofocus]") ||
            this.modal.querySelector(selectors$p.focusable);
          focusTarget?.focus();
        }, 50);
      }
    });
  }

  modalCloseOnProductAdded() {
    this.resetQuickAddButtons();
    if (this.modal && this.modal.hasAttribute("open")) {
      this.modalClose();
    }
  }

  quickAddLoadingToggle(e) {
    if (e.target != this.quickAddHolder) return;

    this.quickAddHolder.classList.remove(classes$i.disabled);
  }

  /**
   * Handle error cart response
   */
  errorHandler() {
    this.quickAddHolder.addEventListener("theme:cart:error", (event) => {
      const holder = event.detail.holder;
      const parentProduct = holder.closest(`[${selectors$p.productGridItem}]`);
      if (!parentProduct) return;

      const errorMessageHolder = holder.querySelector(selectors$p.messageError);
      const hasOverlayText = parentProduct.classList.contains(
        classes$i.overlayText
      );
      const productInfo = parentProduct.querySelector(
        selectors$p.productInformationHolder
      );
      const button = holder.querySelector(selectors$p.buttonAddToCart);

      if (button) {
        button.classList.remove(classes$i.added, classes$i.loading);
        holder.classList.add(classes$i.error);
      }

      if (errorMessageHolder) {
        errorMessageHolder.innerText = event.detail.description;
      }

      if (hasOverlayText) {
        productInfo.classList.add(classes$i.hidden);
      }

      setTimeout(() => {
        this.resetQuickAddButtons();

        if (hasOverlayText) {
          productInfo.classList.remove(classes$i.hidden);
        }
      }, settings.errorDelay);
    });
  }

  /**
   * Reset buttons to default states
   */
  resetQuickAddButtons() {
    if (this.quickAddHolder) {
      this.quickAddHolder.classList.remove(classes$i.visible, classes$i.error);
    }

    if (this.buttonQuickAdd) {
      this.buttonQuickAdd.classList.remove(classes$i.added);
      this.buttonQuickAdd.disabled = false;
    }
  }

  renderModal() {
    if (this.modal) {
      this.modalOpen();
    } else {
      window
        .fetch(`/products/${this.handle}?section_id=api-product-upsell`)
        .then(this.upsellErrorsHandler)
        .then((response) => {
          return response.text();
        })
        .then((response) => {
          this.modalCreate(response);
        });
    }
  }

  modalCreatedCallback() {
    this.modalEvents();
    this.modalOpen();

    wrapElements(this.modal);
  }

  upsellErrorsHandler(response) {
    if (!response.ok) {
      return response.json().then(function (json) {
        const e = new FetchError({
          status: response.statusText,
          headers: response.headers,
          json: json,
        });
        throw e;
      });
    }
    return response;
  }

  resetAnimatedItems() {
    this.modal?.querySelectorAll(selectors$p.animation).forEach((item) => {
      item.classList.remove(classes$i.animated);
    });
  }
}

if (!customElements.get("quick-add-product")) {
  customElements.define("quick-add-product", QuickAddProduct);
}

const selectors$O = {
  actions: "[data-actions]",
  content: "[data-content]",
  trigger: "[data-button]",
};

const attributes$r = {
  height: "data-height",
};

const classes$C = {
  open: "is-open",
  enabled: "is-enabled",
};

class ToggleEllipsis extends HTMLElement {
  constructor() {
    super();

    this.initialHeight = this.getAttribute(attributes$r.height);
    this.content = this.querySelector(selectors$O.content);
    this.trigger = this.querySelector(selectors$O.trigger);
    this.actions = this.querySelector(selectors$O.actions);
    this.toggleActions = this.toggleActions.bind(this);
  }

  connectedCallback() {
    // Make sure the data attribute height value matches the CSS value
    this.setHeight(this.initialHeight);

    this.trigger.addEventListener("click", () => {
      this.setHeight(this.content.offsetHeight);
      this.classList.add(classes$C.open);
    });

    this.setHeight(this.initialHeight);
    this.toggleActions();

    document.addEventListener("theme:resize", this.toggleActions);
  }

  disconnectedCallback() {
    document.removeEventListener("theme:resize", this.toggleActions);
  }

  setHeight(contentHeight) {
    this.style.setProperty("--height", `${contentHeight}px`);
  }

  toggleActions() {
    this.classList.toggle(
      classes$C.enabled,
      this.content.offsetHeight + this.actions.offsetHeight > this.initialHeight
    );
  }
}

if (!customElements.get("toggle-ellipsis")) {
  customElements.define("toggle-ellipsis", ToggleEllipsis);
}
